export enum LinkStyle {
  Button = 'Button',
  HyperLink = 'HyperLink',
  MainCta = 'MainCTA',
}

export enum GridDirection {
  Row = 'row',
  RowReverse = 'row-reverse',
  Column = 'column',
  ColumnReverse = 'column-reverse',
}

export enum Alignment {
  Center = 'Center',
  Left = 'Left',
  Right = 'Right',
}

export enum LayoutBackground {
  Dark = 'Dark',
  Light = 'Light',
}

// CTA colours editors can pick per block (A2P-4465), mapped onto the shared Button's colorVariant.
export type CmsCtaColour = 'Primary' | 'Navy' | 'Teal';

export const ctaColourToButtonVariant: Record<CmsCtaColour, 'primary' | 'shade' | 'teal'> = {
  Primary: 'primary',
  Navy: 'shade',
  Teal: 'teal',
};

// Colour variants for the image + text cover card (A2P-4465), named by background and CTA colour.
export type CoverColourVariant = 'Light_Blue' | 'Light_Navy' | 'Navy';
